import type { ComponentProps } from 'react';
import { Icon } from './Icon';
import type { IconName } from './icons';

export function IconButton({ icon, label, className = '', ...rest }: ComponentProps<'button'> & { icon: IconName; label: string }) {
  return (
    <button type="button" className={`icon-btn ${className}`} aria-label={label} title={label} {...rest}>
      <Icon name={icon} size={20} />
    </button>
  );
}
